<template>
  <div v-if="userId">
    <div v-if="isLoading" class="text-center">
      <ProgressSpinner />
    </div>
    <div v-else>
      <DataTable :value="data" class="p-datatable-sm p-datatable-gridlines" scrollable scrollHeight="155px" autoLayout>
        <Column header="Объект" field="role_name" headerStyle="text-align: center;" />
        <Column header="Управление" bodyStyle="text-align: center;" headerStyle="text-align: center;">
          <template #body="slotProps">
            <Checkbox v-model="slotProps.data.cbox" binary :disabled="!permissions.setting"
              @change="onChange(slotProps.data)" />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, defineProps } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'primevue/usetoast';

const props = defineProps({
  userId: {
    type: Number,
    default: null,
  },
  permissions: {
    type: Object,
    default: () => ({}),
  },
});

const store = useStore();
const toast = useToast();

const isLoading = ref(false);
const data = ref(null);
const userRoleService = ref(null);

const initService = () => {
  if (!userRoleService.value) {
    userRoleService.value = store.getters.nameToService(
      'BaseService',
      store.getters.info.login,
      store.getters.info.password,
      'user_role',
      'data'
    );
  }
};

const loadUserRoles = () => {
  if (!props.userId || props.userId < 0) {
    data.value = [];
    return;
  }
  isLoading.value = true;
  if (!userRoleService.value) {
    initService();
  }
  userRoleService.value
    .getData({ user_id: props.userId })
    .then((res) => {
      data.value = res.map((item) => ({
        ...item,
        cbox: Boolean(item.cbox),
      }));
    })
    .catch((er) =>
      store.commit('SET_ERROR', {
        er: er.response || er,
        source: ['UserRole', 'userId', 'getData'],
      })
    )
    .finally(() => {
      isLoading.value = false;
    });
};

const onChange = (row) => {
  const payload = {
    user_id: row.user_id ?? props.userId,
    role_id: row.role_id,
    cbox: row.cbox,
  };
  if (!userRoleService.value) {
    initService();
  }
  userRoleService.value
    .putData(payload)
    .then(() => {
      toast.add({
        severity: 'success',
        summary: 'Роль обновлена',
        detail: 'Назначение роли пользователя успешно применено',
        life: 1000,
      });
    })
    .catch((er) => {
      store.commit('SET_ERROR', {
        er,
        source: ['UserRole', 'onChange', 'update'],
      });
    });
};

onMounted(() => {
  initService();
  if (props.userId) {
    loadUserRoles();
  }
});

watch(
  () => props.userId,
  (newVal) => {
    if (newVal) {
      loadUserRoles();
    } else {
      data.value = null;
    }
  }
);
</script>

<style lang="scss" scoped>
.image-text {
  vertical-align: middle;
}

.p-treetable .p-treetable-tbody>tr>td {
  padding: 0.2rem 0.2rem !important;
}
</style>